import { SnowflakeThermometerIcon } from './SnowflakeThermometerIcon';

/**
 * author: Michael Irigoyen
 * id C9E4ABED-D38C-45EC-9340-C6C8ADAD1CDF
 * name snowflake-thermometer
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/snowflake-thermometer.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const FreezingPointIcon = SnowflakeThermometerIcon;
export default FreezingPointIcon